import React from 'react'

import { AiIconTip } from 'components_new/molecules/IconTip'
import { Option } from 'components_new/molecules/SelectSearch'
import type { TAttributeOptionDto } from '@homepal/api-contract'
import {
  DatasetType,
  TSortByType,
  VisualizationConstraint
} from 'types/GlobalWidget'

export const getSegmentByOptions = (
  options: TAttributeOptionDto[],
  aiGeneratedText: string
) => {
  return options.map((option) => ({
    title: option.name,
    id: option.id,
    endAdornment: option.ai_generated ? (
      <AiIconTip title={aiGeneratedText} />
    ) : undefined
  }))
}

export const getSortOrderOptions = (
  sortByType: TSortByType,
  allowSortOnKpiVariable: boolean
) => {
  let options: Option[] = []

  switch (sortByType) {
  case DatasetType.DATE:
    options = [
      {
        title: 'Tidigast först',
        id: VisualizationConstraint.SMALLEST
      },
      {
        title: 'Senast först',
        id: VisualizationConstraint.LARGEST
      }
    ]
    break
  case DatasetType.NUMBER:
    options = [
      {
        title: 'Störst värde först',
        id: VisualizationConstraint.LARGEST
      },
      {
        title: 'Minst värde först',
        id: VisualizationConstraint.SMALLEST
      }
    ]
    break
  default:
    options = [
      {
        title: 'Stigande (A till Ö)',
        id: VisualizationConstraint.SMALLEST
      },
      {
        title: 'Fallande (Ö till A)',
        id: VisualizationConstraint.LARGEST
      }
    ]

    break
  }

  if (allowSortOnKpiVariable) {
    options.push({
      title: 'Enligt kontonivåer',
      id: VisualizationConstraint.KPI_VARIABLES
    })
  }

  return options
}
